import "./style.scss";
import { useState } from "react";
import AOPConfig from "./AOPConfig/AOPConfig";
import AOPPrev from "./AOPPrev/AOPPrev";
import { AOPMaltaAcknowledgementData } from "@/src/types/admissionOffice";

const AOPMaltaAcknowledgementLayout = () => {
  const [dataForGeneration, setDataForGeneration] = useState<AOPMaltaAcknowledgementData>({
    currentDate: "",
    fullName: "",
    dateOfBirth: "",
    nationality: "",
    course: "",
    userOffice: "",
    whose_doc: "",
    title: "",
    duration: "",
    mediumOfInstruction: "",
    coursePrefix: "",
    acknowledgmentBody: [],
  });

  const [bodyForPrev, setBodyForPrev] = useState<AOPMaltaAcknowledgementData>({
    currentDate: "",
    fullName: "",
    dateOfBirth: "",
    nationality: "",
    course: "",
    userOffice: "",
    whose_doc: "",
    title: "",
    duration: "",
    mediumOfInstruction: "",
    coursePrefix: "",
    acknowledgmentBody: [],
  });

  return (
    <>
      <div className="container admission-office-page">
        <AOPConfig dataForGeneration={dataForGeneration} setDataForGeneration={setDataForGeneration} setBodyForPrev={setBodyForPrev} />
        <AOPPrev bodyForPrev={bodyForPrev} />
      </div>
    </>
  );
};

export default AOPMaltaAcknowledgementLayout;
